<template>
  <div>
    <vs-button class="mb-6" color="secondary"> 새 역할 생성 </vs-button>

    <vx-card>
      <vs-table
        stripe
        ref="table"
        :data="authGroups"
        search

        pagination
        :sst="true"
        :total="(totalCount) ? totalCount : 1"
        :max-items="itemsPerPage"
        @search="handleTableSearch"
        @selected="handleTableSelected"
        @change-page="handleTableChangePage" >

        <template slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
          <vs-select id="tableSelect" autocomplete label="" v-model="itemsPerPage" class="w-1/12" @change="handleChangeTablePerPage">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in itemsPerPageOptions"/>
          </vs-select>
        </template>

        <template slot="thead">
          <vs-th class="th-fix-name" sort-key="groupName" >
            <vs-col vs-type="flex"  vs-justify="center" >
              권한명
            </vs-col>
          </vs-th>
          <vs-th class="" sort-key="groupName"></vs-th>
          <vs-th class="th-fix-management" >
            <vs-col vs-type="flex"  vs-justify="center" >
              설정
            </vs-col>
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

            <!-- 권한명 -->
            <vs-td style="color: #6670CB;">
              {{ data[indextr].name }}
            </vs-td>
            <vs-td>
              총 권한자 : {{ data[indextr].count }}명
            </vs-td>

            <!-- 설정 -->
            <vs-td class="td-fix-management text-right">
              <vs-button class="" color="#EDEDED" text-color="black" type="filled" @click.stop>삭제</vs-button>
              <vs-button class="ml-4" color="primary" type="border" @click="(event)=>{ handleItemClickModified(event, tr.id) }">수정</vs-button>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>


<script>
import VueCookie from 'vue-cookie'
import memberModule from '@/store/member/memberModule.js'

export default {
  data () {
    return {
      selected: [],
      itemsPerPageOptions: [
        { text: '10', value: 10 },
        { text: '20', value: 20 },
        { text: '50', value: 50 }
      ],
      members: [],
      authGroups: [],

      // pagination
      startNo: 1,
      totalCount: 1,
      currentPage: 1,
      itemsPerPage: 10
    }
  },
  computed: {
  },

  created () {

    // 동적 모듈 등록
    if (!this.$store.hasModule('member')) {
      this.$store.registerModule('member', memberModule)
    }

    this.authGroups = [
      { name: '발주기관실무감독자', count: '1' },
      { name: '시공사 PM', count: '2' },
      { name: '기공사 공사팀장', count: '3' },
      { name: '파트너사 안전보건부서장', count: '4' }
    ]

  },
  mounted () {
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.table.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  beforeDestroy () {
    // 동적 모듈 삭제
    this.$store.unregisterModule('member')
  },

  methods: {

    // 수정페이지로 이동
    moveModified (id) {
      // 선택한 사용자 ID 저장
      VueCookie.set(this.$store.state.member.COOKIE_KEY_CURRENT_USER_ID, id)
      this.$router.push({ path: 'auth/1' })
    },

    // 등록페이지로 이동
    moveRegister () {
      this.$router.push({ path: 'auth/detail' })
    },


    //===== [ dev ] =====

    is_number (v) {
      const reg = /^(\s|\d)+$/
      return reg.test(v)
    },


    //===== [ handler ] ======

    handleItemClickModified (event, id) {
      this.moveModified(id)
    },
    handleFooterClickRegister () {
      this.moveRegister()
    },
    handleChangeTablePerPage (per_page) {
      if (this.is_number(per_page)) {
        this.itemsPerPage = per_page
      }
      this.currentPage = 1
      this.loadMembers(this.currentPage)
    },
    handleTableChangePage (page) {
      this.loadMembers(page)
    },
    handleTableSearch (keyword) {
      const page = this.currentPage
      this.loadMembers(page, keyword)
    },
    handleTableSelected (tr) {
      if (!tr) {
        return
      }
      this.moveModified(tr.id)
    }
  }//methods
}
</script>

<style scoped>
.th-fix-name,
.td-fix-name{
  width:230px;
}
.th-fix-management,
.td-fix-management{
  width:214px;
}

@media (max-width: 992px) {
  .th-fix-management,
  .td-fix-management{
    display: none;
  }
}
</style>
